<template>
  <div>
    <v-card @click="clicked()" class="mx-1 top-border-detail" color="grey lighten-2">
      <v-card-text>
        <v-row dense align="center">
          <v-col>
            <v-list-item-title v-if="oneActionPlan.form.name" v-text="oneActionPlan.form.name"></v-list-item-title>
            <v-list-item-subtitle
              class="caption"
              v-if="oneActionPlan.done_item.title"
              v-text="oneActionPlan.done_item.title"
            ></v-list-item-subtitle>
          </v-col>
          <v-col>
            <v-list-item-subtitle class="caption" v-text="byMe? 'Enviado para' : 'Enviado por'"></v-list-item-subtitle>
            <v-list-item-title
              class="caption font-weight-bold primary--text text--lighten-1"
              v-if="oneActionPlan.info.from"
              v-text="byMe? oneActionPlan.info.who[0].name : oneActionPlan.info.from"
            ></v-list-item-title>
            <v-list-item-subtitle
              class="caption"
              v-if="oneActionPlan.done_at"
              v-text="oneActionPlan.done_at"
            ></v-list-item-subtitle>
          </v-col>
          <v-col>
            <div v-if="oneActionPlan.dead_line">
              <v-list-item-subtitle class="caption" v-text="'Prazo'"></v-list-item-subtitle>
              <v-list-item-subtitle
                class="font-weight-bold red--text text--lighten-2 caption"
                v-if="oneActionPlan.dead_line"
                v-text="oneActionPlan.dead_line"
              ></v-list-item-subtitle>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    oneActionPlan: {
      type: Object,
      required: true
    },
    byMe: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked() {
      this.$emit("handleClicked", this.oneActionPlan.id);
    }
  }
};
</script>
<style scoped>
.top-border-detail {
  box-shadow: 0px 5px inset indigo;
}
</style>